<template>
  <div class="w-screen my-16">
    <BaseContainer class="overflow-hidden">
      <nuxt-error-boundary @error="() => {}">
        <div class="flex items-center justify-end mb-6">
          <div class="flex gap-x-2">
            <div
              :class="
                twJoin(
                  'recommend-c-button-prev w-8 h-8 flex items-center justify-center rounded bg-black text-white cursor-pointer'
                )
              "
            >
              <Icon name="arrow-left" />
            </div>
            <div
              :class="
                twJoin(
                  'recommend-c-button-next w-8 h-8 flex items-center justify-center rounded bg-black text-white cursor-pointer'
                )
              "
            >
              <Icon name="arrow-right" />
            </div>
          </div>
        </div>
        <Swiper
          :modules="[SwiperEffectCreative, SwiperNavigation]"
          :slides-per-view="'auto'"
          :space-between="16"
          :creative-effect="{
            prev: {
              shadow: false,
              translate: ['-20%', 0, -1]
            },
            next: {
              translate: ['100%', 0, 0]
            }
          }"
          :navigation="{
            enabled: true,
            disabledClass: '!bg-gray-10 !text-typo-disabled',
            nextEl: `.recommend-c-button-next`,
            prevEl: `.recommend-c-button-prev`
          }"
          class="!overflow-visible md:!overflow-clip"
        >
          <SwiperSlide
            v-for="(item, index) in data"
            :key="item.objectID"
            class="min-w-[240px] max-w-[240px] md:max-w-[282px]"
          >
            <ProductItemThumbnailComponent
              v-if="item.objectID"
              :key="item.objectID"
              product-listing
              :image-url="item.thumbnail_image_url"
              :name="
                locale === 'en'
                  ? item.display_name_en
                  : item.display_name_th || item.display_name_en
              "
              :tags="
                festiveTags && festiveTags[index] ? [festiveTags[index]] : []
              "
              :price="item.price"
              :personalizable="item.artwork_personalizable"
              :magsafe-compatible="item.product_magsafe_compatible"
              :device-option-available="item.device_option_available"
              :product-slug="item.product_slug"
              :artwork-slug="item.artwork_slug || ''"
              :product-variant-detail-name="
                (locale === 'en'
                  ? item.variable_en
                  : item.variable_en || item.variable_th) || ''
              "
            />
          </SwiperSlide>
        </Swiper>
      </nuxt-error-boundary>
    </BaseContainer>
  </div>
</template>

<script lang="ts" setup>
import { twJoin } from 'tailwind-merge'
const { locale } = useI18n()
const ProductItemThumbnailComponent = defineAsyncComponent({
  loader: () => import('./ProductListItemThumbnail.vue')
})
const props = defineProps<{
  data: AlgoliaProductV2[]
  isLoading?: boolean
  tags:
    | {
        tagsEn: string
        tagsTh?: string
      }[]
    | null
}>()

const festiveTags = computed(() => {
  return props.tags?.map((tag) => ({
    en: tag.tagsEn,
    th: tag.tagsTh || tag.tagsEn,
    color: '#ff4200'
  }))
})
</script>
